import { Component, OnInit } from '@angular/core'
import { AppConfigService } from '@engineering11/tenant-bootstrap-web'

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class AppFooterComponent implements OnInit {
  // @Input() sideNav: boolean = true;

  statusPrivacy: boolean = false
  statusTerms: boolean = false

  logoUrl = this.appConfig.config.brand.logoImageLightUrl
  constructor(private appConfig: AppConfigService) {}

  ngOnInit(): void {}

  modalOpenPrivacy() {
    this.statusPrivacy = true
  }

  modalOpenTerms() {
    this.statusTerms = true
  }

  navigateTo(link: string) {
    window.open(link, '_blank')
  }
}
